<template>
  <el-dialog
    center
    @open="initData"
    :title="$t('История изменений')"
    :visible.sync="modals[nameModal]">
    <table-history :tableData="loadData"
                   :fieldInfoList="fieldInfoList"
                   :load="load"
                   :updateData="updateData"
                   :searchStart="searchStart"
                   :sortData="sortData"
                   :setSort="demo"
                   :backData="backData"
                    configName = "codeEnum"
    >
    </table-history>
    <span slot="footer" class="dialog-footer">
              <button class="btn btn-danger" @click="toggleModal(nameModal)">Закрыть</button>
            </span>
  </el-dialog>
</template>
<script>
  import {HISTORY_CODE_ENUM, RETURN_CODE_ENUM } from "./store/type";
  import {historyModal} from "../../../mixins/history/HistoryModal";

  export default {
    name: 'HistoryCodeEnum',
    mixins: [historyModal],
    data : function () {
      return {
        history : HISTORY_CODE_ENUM,
        return : RETURN_CODE_ENUM,
        paramsReturn : {
          CodeId: this.$route.params.CodeId
        },
        paramsGet : {
          CodeId: this.$route.params.CodeId,
          CodeEnumId : this.$route.params.CodeEnumId,
          self: this
        }
      }
    },
  }
</script>
